import React, { useEffect, useState } from "react";
import { useCompanyReportDeviceInformation } from "src/api/company";
import { Text } from "src/components/ui/Text";
import TableLists from "./TableLists";
import LoadingContainer from "src/components/ui/loading/loading-container";

const AccordionInfoDetails = ({
  id,
  infoView,
  groupSelectStatus,
  informationIconLists,
  selectedRange,
}) => {
  const { data, isLoadingData, isErrorData } =
    useCompanyReportDeviceInformation(
      id,
      infoView === "truck" ? "vehicle" : "charger",
      groupSelectStatus,
      selectedRange
    );
  const [reportInformation, setReportInformation] = useState({});

  useEffect(() => {
    if (data) {
      setReportInformation(data);
    }
  }, [data]);

  const getValueInfoLists = (nameValue) => {
    switch (nameValue) {
      case "Model":
        return reportInformation?.model;

      case "Battery Type":
        return reportInformation?.battery_type || "";

      case "Battery Capacity":
        return `${
          reportInformation?.battery_capacity?.value?.toLocaleString() || ""
        } ${reportInformation?.battery_capacity?.unit || ""}`;

      case "Rated Power":
        return `${
          reportInformation?.rated_power?.value?.toLocaleString() || ""
        } ${reportInformation?.rated_power?.unit || ""}`;

      case "Max Speed":
        return `${
          reportInformation?.max_speed?.value?.toLocaleString() || ""
        } ${reportInformation?.max_speed?.unit || ""}`;

      case "Max Distance":
        return `${
          reportInformation?.max_distance?.value?.toLocaleString() || ""
        } ${reportInformation?.max_distance?.unit || ""}`;

      case "Charging Type":
        return `${reportInformation?.charging_type || ""}`;

      case "Output Power":
        return `${reportInformation?.output_power || ""}`;

      case "Start Mode":
        return `${reportInformation?.start_mode || ""}`;

      default:
        return "";
    }
  };

  return (
    <LoadingContainer isLoading={isLoadingData} hasData={data}>
      <div className="flex gap-4 px-4 py-2 bg-white border-t-2 border-b border-quartenary">
        <div className="flex flex-col items-center gap-1 py-2">
          {reportInformation?.image ? (
            <div className="w-[10.625rem] h-[10.625rem] min-w-[10.625rem]">
              <img
                src={reportInformation?.image}
                alt="devicePicture"
                className="object-cover w-full h-full rounded-full"
              />
            </div>
          ) : (
            <div className="w-[10.625rem] h-[10.625rem] min-w-[10.625rem] bg-vekin-green-50 rounded-full border border-vekin-green40"></div>
          )}

          <Text variant="bold-20" className="text-vekin-green100">
            {reportInformation?.license_plate?.code
              ? reportInformation?.license_plate?.code
              : reportInformation?.name}
          </Text>
          <Text variant="medium-12" className="text-black">
            {reportInformation?.license_plate?.province
              ? reportInformation?.license_plate?.province
              : reportInformation?.branch}
          </Text>
        </div>
        <div className="flex flex-col gap-1">
          <div>
            <Text variant="medium-12" className="py-1 text-tertiary">
              {infoView === "truck"
                ? "Vehicle information"
                : "Station information"}
            </Text>
          </div>
          {informationIconLists?.map(({ name, icon }, index) => {
            return (
              <div
                key={`${name} ${index}`}
                className="flex items-center gap-2 "
              >
                <div className="min-w-[1.625rem]">{icon}</div>
                <Text
                  variant="medium-12"
                  className="text-darkGreen min-w-[9.375rem]"
                >
                  {name}
                </Text>
                <Text variant="semi-12" className="text-darkGreen">
                  {getValueInfoLists(name)}
                </Text>
              </div>
            );
          })}
        </div>
      </div>

      {/* Table Lists */}
      <div>
        <TableLists infoView={infoView} reportInformation={reportInformation} />
      </div>
    </LoadingContainer>
  );
};

export default AccordionInfoDetails;
